<template>
  <div class="u-input custom-number-input">
    <label class="u-input-box" :class="[{'is-not-valid': !number.isValid || inValid, 'disabled': disabled}, classes || {}]" :style="getStyles" @click="$emit('clicked')">
<!--      <span class="input-label" :class="{'is-focus': number.value.toString().length || label.length}">{{ labelPlaceholder || label }}</span><div class="u-input-label-box">-->
      <div class="u-input-label-box">
        <div class="u-input-label-box-start"></div>
        <div v-if="labelPlaceholder || label" class="u-input-label-box-center" :class="[labelPosition]">
          <span class="u-input-label text-subtitle" :class="[{'is-focus': number.value.toString().length || label, 'text-body-1': labelPosition === 'inside'}]">{{ labelPlaceholder || label }}</span>
        </div>
        <div class="u-input-label-box-end"></div>
      </div>
      <div v-if="disabled"
            class="disable-input-value disabled"
            :class="[{'text-primary has-link': Object.values(this.route).length > 0}, $vs.rtl ? 'dir-rtl' : 'dir-ltr']"
            @click="handleClickInput">
        {{ number.value }}
      </div>
      <input v-else
             type="text"
             ref="numberInput"
             :class="[{'disabled': disabled, 'text-primary': Object.values(this.route).length > 0}, $vs.rtl ? 'dir-rtl' : 'dir-ltr']"
             @input="handleInputValue"
             @contextmenu="handleContextMenuClicked($event)"
             @click="handleClickInput"
             @keydown="handleInputKeydown"
             :autocomplete="false"
             :name="Math.random()"
             inputmode="numeric"
             :placeholder="placeholder || ''"
             :disabled="disabled"
             v-model="number.value">
      <div v-if="hasArrow" class="arrow-actions">
        <div class="arrow-action" @click="changeInputStep(1)">
          <custom-icon icon="plus-icon" icon-weight="solid" color="dark-gray" height="8px" width="8px" />
        </div>
        <div class="arrow-action" @click="changeInputStep(-1)">
          <custom-icon icon="minus-icon" icon-weight="solid" color="dark-gray" height="8px" width="8px" />
        </div>
      </div>
      <div v-if="symbol" class="input-symbol">{{ symbol }}</div>
    </label>
  </div>
</template>

<script>
import CustomIcon from "../customIcon/customIcon.vue";

export default {
  name: 'customNumberInput',
  components: {CustomIcon},
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    hasArrow: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    labelPlaceholder: {
      type: String,
      default: ''
    },
    symbol: {
      type: String,
      default: ''
    },
    labelPosition: {
      type: String,
      default: 'outline',
      validator (value) {
        return ['outline', 'outside'].includes(value)
      }
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    inValid: {
      type: Boolean,
      default: () => { return false }
    },
    hasComma: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    route: {
      type: Object,
      default () {
        return {}
      }
    },
    value: {
      type: Object,
      default () {
        return {
          value: '',
          isValid: true
        }
      }
    },
    maxLength: {
      type: Number,
      default: () => { return 0 }
    },
    classes: {
      type: [Object, Array, String],
      default () {
        return {}
      }
    },
    styles: {
      type: Object,
      default () {
        return {}
      }
    },
    min: {
      type: Number,
      default () {
        return -1
      }
    },
    max: {
      type: Number,
      default () {
        return -1
      }
    }
  },
  data () {
    return {
      number: {
        value: '',
        isValid: false
      }
    }
  },
  computed: {
    getStyles () {
      const styles = JSON.parse(JSON.stringify(this.styles))
      // if (!styles.width) {
      //   styles.width = '230px'
      // }

      return styles
    }
  },
  created () {
    if (Object.keys(this.value).length) {
      this.initValues()
    }
    if (this.isEmpty) {
      this.number.isValid = true
    }
  },
  mounted () {
    if (this.autoFocus) {
      this.handleFocusInput()
    }
  },
  methods: {
    handleFocusInput () {
      this.$nextTick(() => {
        const input = this.$refs.numberInput
        if (input) {
          input.select()
        }
      })
    },
    handleInputKeydown (event) {
      switch (event.key) {
        case 'Enter':
          this.handleKeydownEnter()
          break

        case 'ArrowUp':
          this.changeInputStep(1)
          break

        case 'ArrowDown':
          this.changeInputStep(-1)
          break
      }
    },
    changeInputStep (step) {
      if (this.hasArrow) {
        this.number.value = this.$u.parseFloat(this.number.value || 0) + step
        if (this.number.value < 0) {
          this.number.value = 0
          // this.number.value = this.min
        }
        this.handleInputValue()
      }
    },
    handleInputValue () {
      if (this.hasComma) this.addComma()
      else this.number.value = this.number.value.toString().replace(/\D/g, '')
      this.validateValue()
      this.$emit('input', {value: this.number.value.toString().replaceAll(',', ''), isValid: this.number.isValid})
    },
    validateValue () {
      if (this.min !== -1 && this.max !== -1) {
        this.number.isValid = this.$u.parseFloat(this.number.value || '0') >= this.min && this.$u.parseFloat(this.number.value || '0') <= this.max
      } else if (this.isEmpty) {
        this.number.isValid = true
      } else {
        this.number.isValid = this.number.value.toString().length > 0
      }
    },
    addComma () {
      this.number.value = this.$u.priceFormat(this.number.value)
    },
    initValues () {
      this.number.value = this.hasComma ? this.$u.priceFormat(this.value.value) : this.value.value.toString().replace(/\D/g, '')
      this.validateValue()
    },
    handleContextMenuClicked (event) {
      const payload = {
        actions: {
          clipboard: this.number.value,
          paste: true
        },
        event
      }
      this.$store.dispatch('helper/contextMenuClicked', payload)
    },
    handleClickInput () {
      if (Object.values(this.route).length > 0) {
        window.open(this.$router.resolve(this.route).href, '_blank')
      } else {
        this.$emit('clicked')
      }
    },
    handleKeydownEnter () {
      this.$emit('pressEnter')
    }
  },
  watch: {
    'value': {
      handler () {
        this.initValues()
      },
      deep: true
    },

    'number.value': {
      handler (val, prev) {
        if (this.maxLength > 0 && val.length >= this.maxLength) {
          this.number.value = prev
          this.$emit('input', {value: this.number.value.toString().replaceAll(',', ''), isValid: this.number.isValid})
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-number-input {
  position: relative;
  margin: 15px 0 25px;

  .u-input-box {
    display: flex;
    padding: 0;
    border-radius: .5rem;
    transition: all .3s ease;
    gap: 5px;

    &.is-not-valid {
      border-color: #b00000;
      color: #b00000;

      input {
        color: #b00000;
      }
    }

    span {
      padding: 0 5px;
      -webkit-transition: all .3s ease;
      -moz-transition: all .3s ease;
      -o-transition: all .3s ease;
      -ms-transition: all .3s ease;
      transition: all .3s ease;
    }

    input,
    .disable-input-value {
      width: 100%;
      min-height: 42px;
      padding: 6px 10px 6px 5px;
      background: transparent;
      border: none;
      outline: none !important;

      &.dir-rtl {
        direction: rtl;
      }

      &.dir-ltr {
        direction: ltr;
      }

      &.disabled {
        opacity: 0.75;
      }
    }

    .disable-input-value {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .arrow-actions {
      display: flex;
      flex-direction: column;
      gap: 2px;

      .arrow-action {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 3px;
        min-width: 20px;
        border: 1px solid #cecece;
        border-radius: 5px;
      }
    }

    .input-symbol {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px 10px;
      height: 42px;
      font-size: 12px;
      max-height: 100%;
      background-color: #f0f0f0;
      border-radius: 0 0.5rem 0.5rem 0;
      border-left: 1px solid #cecece;
    }
  }
}
</style>
